import React from 'react';
import Transactions from '../../Transactions';
import Heading from '@hubins/components/Heading';
import __ from 'localisation';

const OrdersTransactions = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>{__('all_orders')}</Heading>
      <Transactions />
    </>
  );
};

export default OrdersTransactions;
